module.exports = __webpack_public_path__ + "img/mainLogo.049c7338.png";